module.exports = {
	"header": "Auction",
	"amount": "Amount",
	"auctions": "Auctions",
	"cancelled": "This auction has been cancelled.",
	"category": "Category",
	"created": "The auction has been successfully created.",
	"date": "Auction date",
	"end": "Auction end date",
	"imageAlt": "$t(general::userSubmitted) to represent the auction",
	"listauctions": "Auctions",
	"location": "Auction location",
	"noAuctions": "No auctions.",
	"ongoing": "This auction is live.",
	"notOngoing": "This auction is not ongoing. It might be over.",
	"over": "This auction is over.",
	"status": {
		"cancelled": "Cancelled",
		"finished": "Finished",
		"ongoing": "Ongoing",
		"unpublished": "Unpublished",
		"upcoming": "Upcoming"
	},
	"fullStatus": {
		"cancelled": "Cancelled Auction",
		"cancelled_plural": "Cancelled Auctions",
		"finished": "Finished Auction",
		"finished_plural": "Finished Auctions",
		"live": "Ongoing Auction",
		"live_plural": "Ongoing Auctions",
		"unpublished": "Unpublished Auction",
		"unpublished_plural": "Unpublished Auctions",
		"upcoming": "Upcoming Auction",
		"upcoming_plural": "Upcoming Auctions"
	},
	"shareThis": "Share this auction",
	"unpublished": "This auction has not yet been published. Please try again later.",
	"bidMode": {
		"none": "No bidding",
		"noneDescription": "No pre-bidding enabled on lots. The auction will only allow the display of the lot information and pictures.",
		"standard": "Standard bidding",
		"standardDescription": "Bidders can send regular bids and maximum bids for the lots. The leading bid and bid count information will be displayed on the lot page.",
		"silent": "Silent bidding",
		"silentDescription": "Bidders can send bids for the lots. The lot page will provide no information on who's leading and how many bids has been received."
	},
	"catalog": {
		"bidNow": "Bid now",
		"description": "Description",
		"empty": "This auction has no lots.",
		"endOfCatalog": "End of catalog",
		"increments": "Increments",
		"joinLive": "Join live auction",
		"location": "Location",
		"noDescription": "No description for this lot",
		"noPicture": "No picture for this lot",
		"picture": "Picture",
		"registerForThisAuction": "Register to bid in this auction",
		"sellerId": "Seller ID",
		"subheaderCatalog": "Auction catalog",
		"subheaderInformation": "Auction on",
		"unwatchThisAuction": "Unwatch this auction",
		"unwatchThisLot": "Unwatch this lot",
		"userRequestSent": "Request sent",
		"watchThisAuction": "Watch this auction",
		"watchThisLot": "Watch this lot"
	},
	"lot": {
		"auctionInformation": "Auction information",
		"bid": "Bid",
		"bidAmount": "Bid amount",
		"bidding": "Bidding",
		"biddingNotStarted": "Pre-bidding has not started yet. It will start on __startTime__",
		"biddingOver": "The pre-bidding on this auction is over.",
		"bidRegistered": "Your bid of __amount__ has been registered.",
		"bids": "bids",
		"bidTypes": {
			"automatic": "Automatic bid",
			"liveOnline": "Live online bid",
			"liveOnsite": "Live onsite bid",
			"preBid": "Pre-bid",
			"unknown": "Unknown bid type"
		},
		"currency": "Currency",
		"ended": "Ended",
		"ending": "Ending",
		"endTime": "Pre-bidding end time",
		"enterBid": "Enter a bid",
		"enterMaximumBid": "Enter a maximum bid",
		"enterOrMore": "Enter __amount__ or more",
		"incrementsTable": "Increments table",
		"key": "Label",
		"leadingBid": "Leading bid",
		"logInToBid": "$t(general::pleaseLogIn) to bid...",
		"lot": "lot",
		"lotDetails": "Lot details",
		"lotDetailsHelp": {
			"example": "For example, when adding a car you could use 'Mileage' as the Label and '123,456' as the value.",
			"explanation": "Here you can add specifications or properties of the current lot, to help give potential buyers more context."
		},
		"lots": "lots",
		"lotsListed": "lots listed",
		"makeBid": "Make bid",
		"makeMaximumBid": "Make maximum bid",
		"maximumBid": "Maximum Bid",
		"maximumBidAmount": "Maximum bid amount",
		"nextLot": "Next lot",
		"notBidded": "You have not bid on this lot.",
		"noMaximumSet": "You have not set a maximum bid.",
		"nowLeadingBid": "You have the leading bid.",
		"overBidded": "You have been overbidded! Enter a new bid.",
		"paymentAndPremiums": "Payment & Premiums",
		"previousLot": "Previous lot",
		"standardBid": "Standard Bid",
		"startingBid": "Starting bid",
		"switchInstant": "Switch to instant bidding",
		"switchMaximum": "Switch to maximum bidding",
		"timeLeft": "Time left",
		"value": "Value",
		"youHaveBidded": "You have placed a new bid",
		"youHaveLeadingBid": "You have the leading bid.",
		"youHaveMaximum": "You have set a maximum bid up to"
	},
	"defaultStartingBid": "Default starting bid",
	"preBiddingEndDate": "Pre-bidding end date",
	"preBiddingStartDate": "Pre-bidding start date"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/auction.json5
// module id = 1918
// module chunks = 6